import React from 'react';
import Selector from './Selector';
import Manager from './Manager';
import LoadingCard from '../../../../../../components/loadingCard';

const Select = props => {
    const {
        organization,
        event,
        form,
        rates,
        session,
        remaining_quota,
        onSelect = () => {},
        onOpen = () => {},
        onUnselectRates = () => {},
        manager = true,
        selectorLabel,
        bookingSelectionAuto,
        multiple,
        loading,
        tree,
        selected_rates,
        onChangeSelectedRate = () => {}
    } = props;
    /**
     * USAGE ONLY FOR ADD ATTENDEE PAGES !!!
     */

    // Selector (SelectHierarchy) being an uncontrolled component,
    // we force it to be re-rendered in the event of the deletion of one or more rates
    const [selectorKey, updateSelectorKey] = React.useState(0);
    const onClear = React.useCallback(
        selected_rates => {
            onUnselectRates(selected_rates);
            updateSelectorKey(currentState => currentState + 1);
        },
        [onUnselectRates]
    );

    const indexes = React.useMemo(() => {
        let indexed_rates = {};
        rates.forEach(rate => {
            indexed_rates[rate.id] = rate;
        });
        return indexed_rates;
    }, [rates, session]);

    return (
        <LoadingCard loading={loading}>
            <Selector {...{ key: selectorKey, session, indexes, onSelect, form, tree, rates, loading, organization, event, label: selectorLabel, multiple, onOpen }} />
            {manager && <Manager {...{ selected_rates, bookingSelectionAuto, remaining_quota, rates, form, onClear, onChangeSelectedRate }} />}
        </LoadingCard>
    );
};

export default Select;
